import { isSameOrContains } from 'anodum';
import { connectedStore } from '../../store';
import view from '../../view';

import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import getNotDisabledLiveElement from '../utils/helpers/get-not-disabled-live-element.js';
import pickUpIframe from '../utils/helpers/pick-up-iframe';
import pickUpPhoneLink from '../utils/helpers/pick-up-phone-link';
import isRightClick from '../verifiers/is-right-click';
import getClosestSelectableElement from '../utils/helpers/get-closest-selectable-element';

const elementSelectHandler = (event) => {
  if (isRightClick(event)) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return;
  }

  const { target } = event;
  const element = pickUpIframe(target) || pickUpPhoneLink(target) || target;
  const { element: selectedElement } = getNotDisabledLiveElement(element);
  const store = connectedStore.get();
  const state = store.getState();
  const focusedElementId = view.selectors.getFocusedElement(state);
  const currentFocusedElement = getLiveElement(focusedElementId);

  if (isSameOrContains(currentFocusedElement, selectedElement)) {
    return;
  }

  const interactiveElement = getClosestSelectableElement(selectedElement);
  const interactiveElementId = instance.driver.referenceMap.getReferenceId(interactiveElement);

  if (interactiveElementId) {
    const currentSelectedElementId = view.selectors.getSelectedElement(state);

    if (interactiveElementId !== currentSelectedElementId) {
      store.dispatch(view.actions.setSelectedElement(interactiveElementId));
    }
  } else {
    store.dispatch(view.actions.setSelectedElement(null));
  }

  if (currentFocusedElement) {
    store.dispatch(view.actions.blurFocusedElement({ preserveFocusedTextElement: true }));
  }
};

export default elementSelectHandler;
